import { ChangeEvent, FC } from "react"
import { Tip, TipType } from "../Tip/Tip"
import s from "./UpdateStoks.module.css"
import readXlsxFile from "read-excel-file"
import { windowLock } from "../../utils/loader"
import { Button } from "@radix-ui/themes"

const prepareXLSX = async (file: File) => {
  windowLock()
  const dataFromXslx = await readXlsxFile<{
    name: string
    amount: number
    price: number
  }>(file, {
    schema: schemaDataFromKatren,
  })

  return { data: dataFromXslx.rows, fileName: file.name }
}

type UploadMultipleFilesFromKatrenProps = {
  deleteDataFromKatren: () => void
  isDataFromKatrenUploaded: boolean
  uploadDataFromKatren: (
    data: { name: string; amount: number; price: number }[],
    fileName?: string,
  ) => void
}

export const UploadFileFromKatren: FC<UploadMultipleFilesFromKatrenProps> = ({
  deleteDataFromKatren,
  isDataFromKatrenUploaded,
  uploadDataFromKatren,
}) => {
  return (
    <div className={s.uploadFileWrap}>
      {isDataFromKatrenUploaded ? (
        <div>
          <Button onClick={deleteDataFromKatren}>
            удалить файл цен и остатков с Катрена
          </Button>
        </div>
      ) : (
        <div>
          <Button asChild>
            <label htmlFor={s.priceFromKtrnInp}>
              Загрузить файл цен и остатков с Катрена
              <input
                style={{ display: "none" }}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  const file = e.target.files?.[0]
                  if (file) {
                    prepareXLSX(file).then(({ data, fileName }) => {
                      uploadDataFromKatren(data, fileName)
                    })
                  }
                }}
                type="file"
                accept=".xlsx"
                id={s.priceFromKtrnInp}
              />
            </label>
          </Button>
        </div>
      )}
      <Tip
        content={
          <span>
            <b>Внимание!</b>
            <p>
              Файл цен и остатков должен быть формата <b>XLSX</b> и содержать
              следующие <b>обязательные</b> колонки:
            </p>
            <ol className={s.list}>
              <li>
                <b>Название</b> - название продукта
              </li>
              <li>
                <b>Остаток</b> - остаток на складе катрена
              </li>
              <li>
                <b>Цена за 1 уп.</b> - цена
              </li>
            </ol>
          </span>
        }
        type={TipType.WARNING}
      />
    </div>
  )
}

const schemaDataFromKatren = {
  Название: {
    prop: "name",
    type: String,
  },
  Остаток: {
    prop: "amount",
    type: Number,
  },
  "Цена за 1 уп.": {
    prop: "price",
    type: Number,
  },
}
